import React from 'react'

import { useAppSelector } from 'reduxTyped'
import EmailVerificationModal from 'common/core/components/EmailVerification/EmailVerificationModal'
import { getUserEmail, getUserEmailUnverified } from 'common/core/selectors/appSelectors'
import { isPathnameInclude } from 'utils/router/tools'
import { UserFlag } from 'utils/services/featureFlagsService/constants'
import { useUserReleaseToggle } from 'utils/services/featureFlagsService/releaseTogglesHooks'

const EmailVerificationController = () => {
  const userEmail = useAppSelector(getUserEmail)
  const userEmailUnverified = useAppSelector(getUserEmailUnverified)

  const isBlacklistPath = isPathnameInclude('/questionnaire')

  const needVerification = Boolean(userEmailUnverified) || !userEmail
  const isMandatoryVerification = useUserReleaseToggle(UserFlag.MANDATORY_EMAIL_VERIFICATION)
  const isV2Enabled = useUserReleaseToggle(UserFlag.ENABLE_EMAIL_VERIFICATION_MODAL_V2)
  const showModal = needVerification && isMandatoryVerification && !isBlacklistPath

  return <EmailVerificationModal open={showModal} unskipable={!userEmail || !isV2Enabled} />
}

export default EmailVerificationController
